(() => {
  angular
    .module('finance')
    .controller(
      'finance.views.debugTools.exportTransactionsToNetSuite',
      ExportTransactionsToNetSuiteModalController
    );

  ExportTransactionsToNetSuiteModalController.$inject = [
    '$uibModalInstance',
    '$stateParams',
    'moment',
    'abp.services.finance.debugTools',
  ];

  function ExportTransactionsToNetSuiteModalController(
    $uibModalInstance, 
    $stateParams,
    moment,
    debugToolsSvc
  ) {
    const vm = this;
    
    vm.saving = 0;

    vm.exportTransactionsToNetSuite = exportTransactionsToNetSuite;
    vm.cancel = cancel;

    vm.dateRangeModel = new DateRangeModel(
      $stateParams.startDate,
      $stateParams.endDate
    );

    function DateRangeModel(startDate, endDate, eventCallback) {
      const opt = App.createDateRangePickerOptions();
      this.options = opt;
      this.options.eventHandlers = {
        'apply.daterangepicker': () => {
          eventCallback();
        },
      };
    }

    function exportTransactionsToNetSuite() {
      if (!App.isFormValid(vm.exportTransactionsToNetSuiteForm)) return;
      
      vm.saving += 1;
      debugToolsSvc
        .exportTransactionsToNetSuite({
          maxCount: vm.maxCount,
          chunkSize: vm.chunkSize,
          transactionNumber: vm.transactionNumber,
          startDate: vm.dateRangeModel.startDate 
          ? vm.dateRangeModel.startDate.format('YYYY-MM-DD') : null,
          endDate: vm.dateRangeModel.endDate 
          ? vm.dateRangeModel.endDate.format('YYYY-MM-DD') : null,
          isUpdate: vm.isUpdate,
          delay: vm.delay
        })
        .success(() => {
          abp.notify.success(App.localize('Success'));
        })
        .finally(() => {
          $uibModalInstance.close();
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();